class GatewayTimeout extends Error {
    constructor(message = 'The server, while acting as a gateway or proxy, did not receive a timely response from an upstream server it needed to access in order to complete the request.') {
      super(message)
      this.name = this.constructor.name
      this.status = 504
      Error.captureStackTrace(this, this.constructor)
    }
}

module.exports = GatewayTimeout
